import i18n from '@/plugins/i18n'

export default {
  data () {
    return {
      isCreation: false,
      radioGroup: null,
      headersQuestionTable: [
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'actions'
        },
        {
          text: i18n.t('components.questionnaires.panels.question.label'),
          align: 'left',
          value: 'label'
        },
        {
          text: i18n.t('components.questionnaires.panels.question.text'),
          align: 'left',
          value: 'text'
        }
      ]
    }
  },
  created () {
    if (this.control !== undefined) {
      this.radioGroup = this.control.value
    }
  }
}
